var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Iconly/Bulk/Calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 34",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 1",
    d: "M11.514 31.167c-4.437 0-7.264-2.791-7.264-7.268V13.114h25.5v10.872c0 4.446-2.8 7.181-7.278 7.181z",
    fill: "#7e7e7e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 4",
    d: "M4.255 13.114a22.461 22.461 0 01.22-3.013 6.5 6.5 0 016.214-5.157h12.624a6.572 6.572 0 016.214 5.157 22.514 22.514 0 01.218 3.013z",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 6",
    d: "M11.766 9.333a1.058 1.058 0 001.077-1.088v-4.32a1.059 1.059 0 00-1.077-1.092 1.059 1.059 0 00-1.078 1.092v4.32a1.058 1.058 0 001.078 1.088"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 9",
    d: "M22.235 9.333a1.066 1.066 0 001.077-1.088v-4.32a1.068 1.068 0 00-1.077-1.092 1.059 1.059 0 00-1.078 1.092v4.32a1.058 1.058 0 001.078 1.088"
  })));
}

export default SvgCalendar;